import { render, staticRenderFns } from "./ToggleLabEffect.vue?vue&type=template&id=49e5afb7&scoped=true&"
import script from "./ToggleLabEffect.vue?vue&type=script&lang=js&"
export * from "./ToggleLabEffect.vue?vue&type=script&lang=js&"
import style0 from "./ToggleLabEffect.vue?vue&type=style&index=0&id=49e5afb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e5afb7",
  null
  
)

export default component.exports